const initialState = {
  selectedTariffOptions: []
}

const ActivationTariffOptionsModule = {
  namespaced: true,
  state: initialState,
  getters: {
    savedTariffOptions: state => {
      return state.selectedTariffOptions
    },
    tariffOptionIds: state => {
      return state.selectedTariffOptions.map(option => {
        return { tariffoptionId: option.tariffOptionId }
      })
    }
  },
  actions: {
    selectTariffOptions ({ commit }, { selectedTariffOptions, nextStep = 'topUp' }) {
      if (selectedTariffOptions) {
        commit('storeTariffOptions', selectedTariffOptions)
        commit('activation/goToStep', nextStep, { root: true })
      }
    }
  },
  mutations: {
    storeTariffOptions (state, selectedTariffOptions) {
      state.selectedTariffOptions = selectedTariffOptions
    }
  }
}

export default ActivationTariffOptionsModule
